import React, { useState } from 'react';
import _ from 'lodash';
import Dialog from '@material-ui/core/Dialog';
import Button from 'components/Button';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';

import { Container, Header, Body } from 'styles/pages/home/loginDialog';

const UserDeclineReason = ({ open, onClose }) => {
  const [reason, setReason] = useState(null);
  return (
    <Dialog
      maxWidth='md'
      onBackdropClick={() => onClose()}
      open={open}
      onClose={() => _.isFunction(onClose) && onClose()}>
      <Container>
        <Header>
          <img
            style={{ width: 150, margin: '0 auto' }}
            src='https://bigoventees.com/img/back2.png'
            alt='logo'
          />
        </Header>
        <Body>
          <TextareaAutosize
            value={reason}
            style={{ height: 100, margin: '30px 0' }}
            placeholder='Decline Reason'
            onChange={(e) => setReason(e.target.value)}
          />
          <Button
            disabled={!reason}
            variant='contained'
            containerStyle={{
              backgroundColor: 'red',
              opacity: reason ? 1 : 0.5,
            }}
            title='Decline'
            onClick={() => _.isFunction(onClose) && onClose(reason)}
          />
        </Body>
      </Container>
    </Dialog>
  );
};

export default UserDeclineReason;
